var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"nav-link py-0 text-muted",attrs:{"href":"#","data-bs-toggle":"tooltip","data-bs-placement":"top","title":_vm.$t('Add to favorites')},on:{"click":function($event){$event.preventDefault();return _vm.toggleStar.apply(null, arguments)},"mouseover":_vm.showTooltip,"mouseleave":_vm.hideTooltip}},[_c('i',{class:{
      'far': !_vm.isStarred,
      'fas text-warning': _vm.isStarred,
      'fa-star': true,
    }})])
}
var staticRenderFns = []

export { render, staticRenderFns }